import { render, staticRenderFns } from "./FlowApprovalForm.vue?vue&type=template&id=0f68001c"
import script from "./FlowApprovalForm.vue?vue&type=script&lang=js"
export * from "./FlowApprovalForm.vue?vue&type=script&lang=js"
import style0 from "./FlowApprovalForm.vue?vue&type=style&index=0&id=0f68001c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports